import React from 'react'
import styled from 'styled-components'

import DeviceLinks from 'pages/Customers/DeviceLinks'
import CustomerSearch from 'pages/Customers/CustomerSearch'

import Card from 'components/Card'

import { PageHeader, PageTitle, screenSize } from 'styles/shared'

import { color } from 'styles/colors'

type Props = {
  onSearch: (arg1: string, arg2: string) => void
}

const AdvancedSearch = ({ onSearch }: Props) => {
  return (
    <>
      <S.PageHeader>
        <PageTitle>Customers</PageTitle>
      </S.PageHeader>
      <S.Container>
        <S.Instructions>
          <h2>Who are you looking for?</h2>
          <p>Search, filter and add customers all from the same place.</p>
        </S.Instructions>
        <DeviceLinks isLandingPage />

        <S.Card title="Search">
          <S.CustomerSearch onSearch={onSearch} showSpinner={false} />
        </S.Card>

      </S.Container>
    </>
  )
}

export default AdvancedSearch

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 4% auto;
    align-items: center;
    justify-content: end;
    width: 64%;

    @media ${screenSize.medium}{
      width: 85%;
    }

    @media ${screenSize.small}{
      margin: 0 auto;
      width: 90%;
    }
  `,
  Instructions: styled.div`
    text-align: center;
    max-width: 600px;
    h2{
      font-size: 32px;
      margin-bottom: 0px;
      color: ${color('customerInstructionText')};

      @media ${screenSize.small}{
        font-size: 26px;
      }
    }
    p{
      font-size: 16px;
      @media ${screenSize.small}{
        font-size: 14px;
      }
    }
  `,
  CustomerSearch: styled(CustomerSearch)`
    display: inline-block;
    white-space: nowrap;
    width: 100%;

    & > :nth-child(2) {
      top: 5%;
      height: auto;

      @media ${screenSize.small}{
        top: 10%;
        height: 80vh;
      }
    }

    form,
    input {
      width: 100%;
    }
  `,
  Card: styled(Card)`
    width: 100%;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 160px;
    padding: 24px;

    h2{
      color: ${color('customerInstructionText')};
      margin-top: 10px;
    }

    @media ${screenSize.small}{
      gap: 15px;
      min-height: 135px;
      padding: 10px;
    }
  `,
  PageHeader: styled(PageHeader)`
    margin-bottom: 0;
  `
}
